// Libraries
import { Button } from '@chakra-ui/react';
import { Fragment } from 'react';
// Components
import { ResetIcon } from '@atoms/Icons';
import { useUnitAndRangeStore } from '@stores/index';
// Utils
import text from '@translations/en.json';
// Types
import { ClearFiltersButtonProps } from './ClearFiltersButton.types';

/**
 * A reusable component that renders a Clear Filters button for a table.
 * This button clears the column filters applied to the table.
 *
 * @component
 * @param {ClearFiltersButtonProps} props - The props for the ClearFiltersButton component.
 * @param {Table} props.table - The table instance that holds the column filters.
 *
 * @returns {ReactElement} JSX element representing the ClearFiltersButton.
 */
export const ClearFiltersButton = ({ columnFiltersLength, setColumnFilters }: ClearFiltersButtonProps) => {
  // This clears the unitAndRange state filter
  const { clear } = useUnitAndRangeStore();

  const onClick = () => {
    clear();
    setColumnFilters([]);
  };

  return (
    <Fragment>
      {columnFiltersLength > 0 && (
        <Button
          variant='baseLight'
          fontSize='m'
          fontWeight='medium'
          onClick={onClick}
          color='tealishBlue'
          _hover={{
            background: 'none',
          }}
          display={{
            base: 'none',
            md: 'block',
          }}
          leftIcon={<ResetIcon boxSize={2.5} mr={-1} color='tealishBlue' />}
        >
          {text.clear_filters}
        </Button>
      )}
    </Fragment>
  );
};
